import { Minus, Plus, Trash2 } from "lucide-react";
import { lineKey, useCart } from "./CartContext";
import { imgUrl, money } from "../useProducts";

export const CartLine = ({ item, compact = false }) => {
  const { setQuantity, remove } = useCart();
  const k = lineKey(item);
  const meta = [item.optionLabel !== item.productName ? item.optionLabel : null, item.color, item.size && item.size !== "ONE SIZE" ? `Size ${item.size}` : null].filter(Boolean).join(" · ");
  return (
    <li data-testid={`cart-line-${item.lookupKey}`} className={`flex gap-4 ${compact ? "py-4" : "py-5"} border-b border-[#e3e2dc] last:border-0`}>
      <div className={`${compact ? "h-20 w-16" : "h-28 w-20 sm:h-32 sm:w-24"} shrink-0 rounded-xl overflow-hidden bg-[#f3f2ec]`}>
        {item.image && <img src={imgUrl(item.image)} alt={item.productName} className="h-full w-full object-cover object-top" />}
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-start justify-between gap-3">
          <div className="min-w-0">
            <p className="font-display font-extrabold uppercase text-[12px] sm:text-sm leading-tight truncate">{item.productName}</p>
            {meta && <p className="font-mono-d text-[9px] uppercase tracking-[0.15em] text-[#5f5e5a] mt-1">{meta}</p>}
          </div>
          <p data-testid={`cart-line-total-${item.lookupKey}`} className="font-mono-d text-sm shrink-0">{money(item.price * item.quantity)}</p>
        </div>
        <div className="mt-3 flex items-center justify-between gap-3">
          <div className="inline-flex items-center rounded-full border border-[#e3e2dc] bg-[#ffffff]">
            <button type="button" data-testid={`cart-qty-minus-${item.lookupKey}`} aria-label="Decrease quantity" onClick={() => setQuantity(k, item.quantity - 1)} className="h-8 w-8 flex items-center justify-center hover:text-[#ff2a85]"><Minus size={12} /></button>
            <span data-testid={`cart-qty-${item.lookupKey}`} className="w-6 text-center font-mono-d text-xs">{item.quantity}</span>
            <button type="button" data-testid={`cart-qty-plus-${item.lookupKey}`} aria-label="Increase quantity" disabled={item.quantity >= 5} onClick={() => setQuantity(k, item.quantity + 1)} className="h-8 w-8 flex items-center justify-center hover:text-[#ff2a85] disabled:opacity-40"><Plus size={12} /></button>
          </div>
          <button type="button" data-testid={`cart-remove-${item.lookupKey}`} onClick={() => remove(k)} className="inline-flex items-center gap-1 font-mono-d text-[9px] uppercase tracking-[0.15em] text-[#5f5e5a] hover:text-[#ff2a85] transition-colors">
            <Trash2 size={11} /> Remove
          </button>
        </div>
      </div>
    </li>
  );
};
